import { Card, Tabs } from 'antd';
import React, { useState } from 'react';
import { useAdminPokemon } from '../../../Hooks/Admin';

export const Pokemon = () => {
    const [activeTabKey, setActiveTabKey] = useState("lista");

    const tabs = useAdminPokemon({ setKey: setActiveTabKey });

    const onTabChange = (key) => {
        setActiveTabKey(key);
    };

    const tabItems = [
        { key: "lista",        label: "Lista de Pokémon",        children: tabs["lista"] },
        { key: "data",         label: "Data",                    children: tabs["data"] },
        { key: "imagenes",     label: "Imágenes",                children: tabs["imagenes"] },
        { key: "requerimiento",label: "Requerimiento de evolución", children: tabs["requerimiento"] },
    ];

    return (
        <Card style={{ width: "100%" }}>
            <Tabs
                items={tabItems}
                activeKey={activeTabKey}
                onChange={onTabChange}
                tabProps={{ size: "small" }}
            />
        </Card>
    );
};
